var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jr-card"},[(_vm.title)?_c('h2',{staticClass:"title-text"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.status)?[_c('icon-status',{attrs:{"color":_vm.color,"status":_vm.status}})]:_vm._e()],2):_vm._e(),_vm._t("title"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }